<template>
  <v-dialog v-model="open" max-width="500px">
    <v-card>
      <v-card-title>
        <span>{{
          type == 'qr' ? $T('page.member.invite.method.qr.title') : $T('page.member.invite.method.link.title')
        }}</span>
        <v-spacer></v-spacer>
      </v-card-title>
      <v-container grid-list-lg text-xs-left>
        <v-layout column wrap>
          <v-flex>
            <select-community v-model="communityId" ref="selectCommunity" />
          </v-flex>
          <v-flex>
            <div class="c-flex-container">
              <div class="l">
                <v-select
                  data-vv-name="expire"
                  :items="expireItems()"
                  ref="'input_expire'"
                  :label="$T('attributes.expire')"
                  v-model="expire"
                  color="clr-primary"
                  v-validate="'required'"
                  :error-messages="getMessage('expire')"
                  required
                  :disabled="loading"
                ></v-select>
              </div>
              <div class="r">
                <v-select
                  data-vv-name="expireUnit"
                  :items="expireUnits()"
                  item-text="t"
                  item-value="v"
                  ref="'input_expire_unit'"
                  v-model="expireUnit"
                  color="clr-primary"
                  v-validate="'required'"
                  :error-messages="getMessage('expireUnit')"
                  required
                  :disabled="loading"
                ></v-select>
              </div>
            </div>
          </v-flex>
        </v-layout>
      </v-container>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="clr-btn-cancel" flat @click.native="closeDialog" :disabled="loading">{{ $T('button.close') }}</v-btn>
        <v-btn color="clr-btn" flat @click.native="createNew" :disabled="!isSavable" :loading="loading">{{
          $T('page.member.invite.create.button')
        }}</v-btn>
        <v-spacer></v-spacer>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { invitable, createInviteLink } from '../../api/communityMember';

export default {
  data() {
    return {
      type: null,
      communityId: null,
      expire: null,
      expireUnit: null,
      creatable: false,
      open: false,
      loading: false,
      apiErrors: {},
    };
  },
  watch: {
    communityId(newValue, oldValue) {
      if (!newValue || newValue <= 0) {
        this.creatable = false;
        return;
      }
      this.loading = true;
      this.creatable = false;
      var _this = this;
      invitable(newValue)
        .then(function(response) {
          _this.creatable = response == 1 || response == 2;
          if (!_this.creatable) {
            _this.$refs.selectCommunity.addError(_this.communityId, $T('page.member.invite.noauth'));
          }
          _this.loading = false;
        })
        .catch(function(error) {
          console.log(error);
          _this.loading = false;
        });
    },
  },
  computed: {
    isSavable() {
      return !this.loading && this.creatable;
    },
  },
  methods: {
    createNew() {
      var cid = this.communityId;

      var data = new FormData();
      data.append('cid', cid);
      data.append('expire', this.expire);
      data.append('expireUnit', this.expireUnit);

      this.loading = true;
      var _this = this;
      createInviteLink(data)
        .then(function(response) {
          _this.loading = false;
          _this.$emit('invited', _this.type, cid, response);
          _this.closeDialog();
        })
        .catch(function(error) {
          console.log(error);
          _this.$refs.selectCommunity.addError(cid, $T('common.failed.register'));
          _this.loading = false;
        });
    },
    openDialog(type, expire, expireUnit, communityId) {
      this.type = type;
      this.expire = expire;
      this.expireUnit = expireUnit;
      this.communityId = communityId;
      this.open = true;
      setTimeout(this.initFocus, 500);
    },
    initFocus() {
      if (!this.communityId) {
        this.$refs.selectCommunity.focus();
        return;
      }
    },
    closeDialog() {
      this.open = false;
    },
    expireItems() {
      var vs = [];
      for (var i = 1; i <= 100; i++) {
        vs.push(i);
      }
      return vs;
    },
    expireUnits() {
      return [
        { v: 'm', t: $T('common.unit.min') },
        { v: 'h', t: $T('common.unit.hour') },
        { v: 'd', t: $T('common.unit.day') },
        { v: 'M', t: $T('common.unit.month') },
        { v: 'y', t: $T('common.unit.year') },
      ];
    },
    getMessage(fieldName) {
      return this.apiErrors[fieldName] && this.apiErrors[fieldName][this.inputValue]
        ? this.apiErrors[fieldName][this.inputValue]
        : this.errors.collect(fieldName);
    },
  },
};
</script>

<style scoped>
.container {
  padding: 0px 24px 12px 24px;
}
.c-flex-container {
  display: flex;
  width: 250px;
}
.c-flex-container .l {
  width: 150px;
}
.c-flex-container .r {
  width: 90px;
  padding-left: 10px;
}
</style>
